import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

import { useClassName } from 'hooks/useClassName';
import { useSearch } from 'hooks/useSearch';

/**
 * An input component that opens the search modal when submitted.
 *
 * @returns {JSX.Element} The search input component
 */
const SearchInput = () => {
  const { showSearch, query, updateQuery } = useSearch();

  const c = useClassName('search');

  const handleSearchUpdate = (e) => {
    const {
      target: { value },
    } = e;
    updateQuery(value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    showSearch(query);
  };

  return (
    <div {...c()}>
      <div {...c('container')}>
        <form onSubmit={handleSearch}>
          <input
            type="text"
            {...c('input')}
            placeholder={i18n.translate('general.search')}
            onChange={handleSearchUpdate}
            value={query}
          />
          <button type="submit" {...c('button')}>
            <FontAwesomeIcon icon={['fas', 'search']} aria-label={i18n.translate('general.search')} />
          </button>
        </form>
      </div>
    </div>
  );
};

SearchInput.propTypes = {
  refreshQuery: PropTypes.bool,
};

export default SearchInput;
